// extracted by mini-css-extract-plugin
export default {"filter-panel-container":"zHOB1d","view-filters-container":"KXzM5X","view-filters-form":"TcSpOk"};